// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VgdM-","buttons":"styles_buttons__2y5WL"};